<script lang="ts" setup>
import { computed } from "vue";

const props = withDefaults(defineProps<{ price: number; displayPrice: boolean; purpose: number; currency: string; makeOffer?: boolean; labelClass?: string }>(), {
    displayPrice: false,
    makeOffer: false,
    labelClass: "text-14 text-white bg-brand px-12 py-4",
});

const computedPrice = computed(() => {
    let symbol: string = props.currency;
    const price: string = `${props.price}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    if (props.purpose === 1) {
        return `${symbol} ${price}`;
    } else if (props.purpose === 2) {
        return `${symbol} ${price}/maand`;
    } else if (props.purpose === 5) {
        return `In optie`;
    }

    return "";
});
</script>

<template>
    <div v-if="price && displayPrice">
        <template v-if="[1, 2, 5].includes(purpose)">
            <span v-if="makeOffer">Vanaf</span>
            {{ computedPrice }}
        </template>
        <span v-else :class="labelClass">Verkocht</span>
    </div>
</template>
